import { Card, CardContent } from '@/components/ui/card';
import RegisterForm from '@/modules/auth/register-form';
import { Link } from 'react-router-dom';

const RegisterPage = () => {
  return (
    <div className='flex h-screen w-full flex-col bg-white'>
      <main className='flex flex-1 items-center justify-center'>
        <Card className='mx-auto w-full max-w-md border-0 bg-white shadow-none'>
          <CardContent className='px-0 pt-6'>
            <div className='mb-8 text-center'>
              <h1 className='mb-2 text-2xl font-bold text-gray-700'>
                Setup Account
              </h1>
              <p className='text-gray-600'>
                Let’s get you started right away.
              </p>
            </div>

            <RegisterForm />
            <div className='mt-2 text-center font-grotesk'>
              Have an account already?
              <Link to={'/sign-in'} className='font-medium text-[#2658AB]'>
                Login here
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}

export default RegisterPage